import React from "react";

import { ProductTileSurface } from "./ProductTileSurface";

interface IProductTileSurfaceContext {
  productTileSurface?: ProductTileSurface;
}

export const ProductTileSurfaceContext =
  React.createContext<IProductTileSurfaceContext>({});
